module.exports = __webpack_public_path__ + "static/img/Chemistry.acd2578.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Chemistry.png
// module id = 2233
// module chunks = 61